import { GUIDE_TOUR_BLOCKED_TARGET_INTERACTION_MESSAGE_LINES } from '../types'
import type { GuideTourStep, GuideTourStepCardSize } from '../types'
import * as S from './styles'

export type GuideTourStepCardHeaderProps = Readonly<{
  hiddenHeader?: boolean
  currentStep: GuideTourStep
  currentStepNumber: number
  stepCount: number
  isSummaryOnly: boolean
  isTourUnavailablePage?: boolean
  routeTourQueue: { position: number; total: number } | null
  skippedStepNoticeMessage: string | null
  isBlockedTargetInteractionWarningVisible: boolean
  cardSize: GuideTourStepCardSize
  onDismiss: () => void
}>

export function GuideTourStepCardHeader({
  hiddenHeader = false,
  currentStep,
  currentStepNumber,
  stepCount,
  isSummaryOnly,
  isTourUnavailablePage = false,
  routeTourQueue,
  skippedStepNoticeMessage,
  isBlockedTargetInteractionWarningVisible,
  cardSize,
  onDismiss,
}: GuideTourStepCardHeaderProps) {
  const stepLabel = isSummaryOnly
    ? 'Tour de novidades'
    : `Passo ${currentStepNumber} de ${stepCount}`

  if (hiddenHeader) {
    if (isTourUnavailablePage) {
      return null
    }

    if (isSummaryOnly) {
      return (
        <S.CompactStepMeta data-testid="guide-tour-step-compact-meta">
          <S.StepLabel $cardSize={cardSize}>{stepLabel}</S.StepLabel>
        </S.CompactStepMeta>
      )
    }

    return (
      <S.CompactStepMeta data-testid="guide-tour-step-compact-meta">
        <S.HeaderTopRow>
          <S.StepMetaColumn>
            {routeTourQueue ? (
              <S.RouteTourLabel data-testid="guide-tour-route-queue-label">
                Novidade {routeTourQueue.position} de {routeTourQueue.total}
              </S.RouteTourLabel>
            ) : null}
            <S.StepLabel $cardSize={cardSize}>{stepLabel}</S.StepLabel>
          </S.StepMetaColumn>
          <S.CloseButton
            type="button"
            aria-label="Dispensar tour"
            data-testid="guide-tour-dismiss-button"
            onClick={onDismiss}
          >
            ×
          </S.CloseButton>
        </S.HeaderTopRow>
      </S.CompactStepMeta>
    )
  }

  return (
    <S.Header>
      {routeTourQueue ? (
        <S.RouteTourLabel data-testid="guide-tour-route-queue-label">
          Novidade {routeTourQueue.position} de {routeTourQueue.total}
        </S.RouteTourLabel>
      ) : null}

      <S.HeaderTopRow>
        <S.StepMetaColumn>
          <S.StepLabel $cardSize={cardSize}>{stepLabel}</S.StepLabel>
          {currentStep.badge ? <S.Badge>{currentStep.badge}</S.Badge> : null}
        </S.StepMetaColumn>
        {!isSummaryOnly ? (
          <S.CloseButton
            type="button"
            aria-label="Dispensar tour"
            data-testid="guide-tour-dismiss-button"
            onClick={onDismiss}
          >
            ×
          </S.CloseButton>
        ) : null}
      </S.HeaderTopRow>

      {skippedStepNoticeMessage ? (
        <S.SkippedStepInfoNotice
          data-testid="guide-tour-skipped-step-notice"
          id="guide-tour-skipped-step-notice"
          role="status"
        >
          <span>
            {isSummaryOnly ? (
              <span id="guide-tour-skipped-summary-title">
                {skippedStepNoticeMessage}
              </span>
            ) : (
              skippedStepNoticeMessage
            )}
          </span>
        </S.SkippedStepInfoNotice>
      ) : null}
      {isBlockedTargetInteractionWarningVisible ? (
        <S.BlockedInteractionDangerNotice
          data-testid="guide-tour-blocked-interaction-warning"
          role="alert"
        >
          {GUIDE_TOUR_BLOCKED_TARGET_INTERACTION_MESSAGE_LINES.map(line => (
            <span key={line}>{line}</span>
          ))}
        </S.BlockedInteractionDangerNotice>
      ) : null}
    </S.Header>
  )
}
